import React from 'react';
import { object, array } from 'yup';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FormControlWrapper from 'components/interaction/Form4/FormControlWrapper.jsx';
import AddFiles from './index.jsx';
import splitFiles from './splitFiles.js';
import messages from './messages.js';

function Attachments(props) {
  const { value, onChange, onBlur, className, ...rest } = props;
  const files = [...value.media, ...value.newMedia];
  const handleChange = (newFiles) => {
    const [media, newMedia] = splitFiles(newFiles);
    onBlur();
    onChange({ media, newMedia });
  };
  const classList = classNames([className, 'w-100']);
  return (
    <FormControlWrapper className={classList} border={2}>
      <AddFiles {...rest} files={files} onChange={handleChange} />
    </FormControlWrapper>
  );
}

Attachments.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string,
};

Attachments.getSchema = (options, intl) => {
  const result = object().shape({
    media: array(),
    newMedia: array()
      .test('loading', () => intl.formatMessage(messages.loading), (val) => !val.some((o) => o.loading))
      .label(intl.formatMessage(options.label || messages.this)),
  });
  const { required } = options;
  if (required) {
    result.fields.newMedia = result.fields.newMedia.when('media', {
      is: (val) => val?.length > 0,
      otherwise: ((s) => s.min(1)),
    });
  }
  return result;
  // .test('loading', () => messages.loading, (val) => !val.fields.newMedia.some((o) => o.loading));
};

export default Attachments;
